<template>
  <div 
    class="svga-container"
 
    :style="{ width, height }"
  >
  
    <!-- 静态图片（始终存在，通过 z-index 控制显示层级） -->
    <img 
      :src="staticImage" 
      :alt="altText"
      class="static-image"
      :class="{ 'opacity-0': isPlaying }"  
      @error="handleImageError"
    >
    
    <!-- SVGA播放器容器（播放时显示，结束后隐藏） -->
    <div 
      ref="svgaPlayerContainer" 
      class="svga-player"
      :class="{ 'opacity-0': !isPlaying }"  
    ></div>

     <div 
     v-if="several==2"
      ref="svgaPlayerContainer2" 
      class="svga-player"
      :class="{ 'opacity-0': !isPlaying2 }"  
    ></div>

    <div class="shadow"></div>
  </div>
</template>


<script>
import SVGA  from 'svgaplayerweb'
export default {
  name: 'SvgaPlayerImage',
  props: {
    staticImage: {
      type: String,
      required: true
    },
    svgaSrc: {
      type: String,
      required: true,
      validator: (value) => typeof value === 'string'
    },
    svgaSrc2: {
      type: String,
      required: true,
      validator: (value) => typeof value === 'string'
    },
    altText: {
      type: String,
      default: '图片'
    },
    width: {
      type: [String, Number],
      default: 'auto'
    },
    height: {
      type: [String, Number],
      default: 'auto'
    },
    several: {
      type: [String, Number],
      default: '1'
    },
    loop: {
      type: Boolean,
      default: false
    },
    // 新增：接收父组件传递的控制状态
    triggerPlay: {
      type: Boolean,
      default: false
    },
    triggerPlay1: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isClient: false,
      isPlaying: false,
      isPlaying2: false,
      player: null,
      player2: null,
      parser: null,
      parser2: null,
      imageError: false,
      svgaError: false,
      SVGA: null,
      // 新增：加载状态标记
      isLoading: false,
      isLoading2: false,
    }
  },
  async mounted() {
    this.isClient = process.client
    
    //if (this.isClient) {
      try {
        //const svgaModule = await import('svgaplayerweb')
        this.SVGA = SVGA; //svgaModule.default
        this.initPlayer()
      } catch (error) {
        console.error('加载svgaplayerweb失败:', error)
        this.svgaError = true
      }
    //}
  },
  beforeDestroy() {
    if (this.player) {
      this.player.stopAnimation()
      this.player = null
    }
    this.parser = null
  },
  // 新增：监听父组件传递的状态变化
  watch: {
    triggerPlay(newVal) {
      if (newVal) {
        this.playSvga()
      } else {
        this.stopSvga()
      }
    },
    width: {
      immediate: true,
      handler(val) {
        if ( this.$el) {
          this.$el.style.width = typeof val === 'number' ? `${val}px` : val
        }
      }
    },
    height: {
      immediate: true,
      handler(val) {
        if ( this.$el) {
          this.$el.style.height = typeof val === 'number' ? `${val}px` : val
        }
      }
    }
  },
  methods: {
    initPlayer() {
      console.log("99999999999",this.SVGA);
      if (!this.SVGA ) return //|| !this.isClient
      
      this.player = new this.SVGA.Player(this.$refs.svgaPlayerContainer);
      this.player.loops = 1;//this.loop ? 0 : 1; // 根据loop属性设置循环次数，0为无限循环
      this.player.clearsAfterStop = false;
      this.parser = new this.SVGA.Parser()
      //if(this.several == 2){
        this.player2 = new this.SVGA.Player(this.$refs.svgaPlayerContainer2);
        this.player2.loops = 1;//this.loop ? 0 : 1; // 根据loop属性设置循环次数，0为无限循环
        this.parser2 = new this.SVGA.Parser();
      //}
      this.setupPlayerEvents()
    },
    setupPlayerEvents() {
      if (!this.player) return
      
      const handleFinished = () => {
        this.player.stopAnimation();
        this.isPlaying = false;
        this.isPlaying2 = false;
        // 通知父组件动画已结束
        this.$emit('animation-finished');
        // 清空SVGA画布内容
        if (this.player.canvas) {
          const ctx = this.player.canvas.getContext('2d');
          ctx.clearRect(0, 0, this.player.canvas.width, this.player.canvas.height);
        }
      };
      
      // 绑定事件（兼容不同版本）
      if (typeof this.player.onFinished === 'function') {
        this.player.onFinished(handleFinished);
      } else if (this.player.addEventListener) {
        this.player.addEventListener('finished', handleFinished);
      }
      
      // 错误事件处理
      if (this.player.addEventListener) {
        this.player.addEventListener('error', (error) => {
          console.error('SVGA播放器错误:', error);
          this.svgaError = true;
          this.isPlaying = false;
          this.$emit('animation-error', error);
        });
      }
    },
    
    async playSvga() {
      if (!this.SVGA || !this.parser || this.isPlaying || this.svgaError) return;
      this.isLoading = true; // 开始加载时标记
      
      this.$nextTick(async () => {
        try {
          const videoItem = await new Promise((resolve, reject) => {
            this.parser.load(this.svgaSrc, resolve, reject);
          });
          this.player.setVideoItem(videoItem);
          this.player.startAnimation();

          this.isPlaying = true;
          this.isPlaying2 = false;
          this.svgaError = false;
          console.log("=====werwewe",this.svgaSrc);
          // 计算最后一帧索引
          if(this.several == 2){
            const lastFrame = videoItem.frames - 1;
            
            // 跳转到最后一帧并暂停
            setTimeout(() => {
            this.player.stepToFrame(lastFrame, false);
            this.player.pauseAnimation();
            }, 800) 
          }
        } catch (error) {
          console.error('播放SVGA失败:', error);
          this.svgaError = true;
          this.isPlaying = false;
          this.isLoading = false;
          //this.$emit('animation-error', error);
        }
      });
    },

    async stopSvga() {
      if ( !this.player || !this.isPlaying) return
      
      this.player.stopAnimation()
      setTimeout(() => {
        this.isPlaying = false;
      }, 50);
      
      
      if(this.several == 2 && this.svgaSrc2){
        this.isLoading2 = true; // 标记第二个动画加载中
            this.$nextTick(async () => {
            try {
            const videoItem = await new Promise((resolve, reject) => {
                this.parser2.load(this.svgaSrc2, resolve, reject);
            });
            this.player2.setVideoItem(videoItem);
            this.player2.startAnimation();
            // 加载完成后显示第二个动画
            this.isLoading2 = false;
            this.isPlaying2 = true;
            } catch (error) {
            console.error('播放SVGA失败:', error);
            this.svgaError = true;
            this.isPlaying = false;
            this.isLoading2 = false;
            //this.$emit('animation-error', error);
            }
        });
      }
    },
    handleImageError() {
      this.imageError = true
      console.error('静态图片加载失败:', this.staticImage)
      //this.$emit('image-error', this.staticImage)
    }
  }
}
</script>

<style scoped>
.hidden {
  display: none !important;
}
.opacity-0 {
  opacity: 0 !important;
  pointer-events: none; /* 透明时不响应事件 */
}

.svga-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.static-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.2s ease-in-out; /* 平滑过渡 */
  position: relative;
  z-index: 1;
}

.svga-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 2;
  transition: opacity 0.2s ease-in-out; /* 平滑过渡 */
}


.error-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  color: #999;
  border: 1px dashed #ddd;
}

.error-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
}

.shadow{
    width: 24px;
    height: 8px;
    background: rgba(32, 109, 234, 0.8);
    -webkit-filter: blur(8px);
    filter: blur(8px);
    margin-left: 8px;
    position: absolute;
    top: 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/guide/SvgaHoverImage.vue